import React from "react";

import { useNavigate } from "react-router-dom";

const SwachBharatPhotos = () => {
  const navigate = useNavigate();

  const photosGalleryData = [
    {
      field_image_media:
        "https://neepco.co.in/sites/default/files/AGBP-SBP1-0518_0.jpg",
      field_date_media: "2023-01-01",
      title: "Photo 1",
    },
    {
      field_image_media:
        "	https://neepco.co.in/sites/default/files/AGBP-SBP2-0518_0.jpg",
      field_date_media: "2023-01-02",
      title: "Photo 2",
    },
    {
      field_image_media:
        "https://neepco.co.in/sites/default/files/HO-SBP-0518_0.jpg",
      field_date_media: "2023-01-03",
      title: "Photo 3",
    },
  ];

  return (
    <>
      <div>
        {photosGalleryData.map((item, index) => (
          <div className="card-sec" key={index}>
            <div className="img-sec">
              <img
                src={`${process.env.REACT_APP_IMAGE_URL}/${item?.field_image_media}`}
                alt={item.title}
              />
            </div>
            <div className="desc-sec">
              <p>{item.title.slice(0, 70)}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex-box">
        <div className="btn-sec">
          {/* <button className="btnPause">
            <div className="arrowGallery">
              <span className="left" onClick={prev}>
                <i className="fa fa-angle-left"></i>
              </span>
              <a className="pause-btn" onClick={HandlePlayPause}>
                {!playPause ? (
                  <i className="fas fa-pause"></i>
                ) : (
                  <i className="fas fa-play"></i>
                )}
              </a>
              <span className="right" onClick={next}>
                <i className="fa fa-angle-right"></i>
              </span>
            </div>
          </button> */}
          <a
            href="#"
            className="quick-btn"
            onClick={(e) => {
              e.preventDefault();
              navigate("/swachh-bharat-photos");
            }}
          >
            View All
          </a>
        </div>
      </div>
    </>
  );
};

export default SwachBharatPhotos;
